import { Pagination } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as taskRedux from '../redux/TaskRedux';
import TaskTable from './TaskTable';

function NotReachableExpiredTable() {
  const dispatch = useDispatch();
  const tasks = useSelector(taskRedux.notReachableExpiredTasksSelector);
  const status = useSelector(taskRedux.notReachableExpiredTasksStatusSelector);
  const page = useSelector(taskRedux.notReachablePageSelector);
  const count = useSelector(taskRedux.notReachableCountSelector);

  useEffect(() => {
    dispatch(taskRedux.actions.retrieveNotReachableExpiredTasks());
  }, []);

  function onPageChange(event, page) {
    dispatch(taskRedux.actions.retrieveNotReachableExpiredTasks(page));
  }

  return (
    <div className="card w-100">
      <div className="card-body position-relative" id="kt_not_reachable_body">
        <TaskTable
          tasks={tasks}
          displayOwner={false}
          onRefresh={() =>
            dispatch(taskRedux.actions.retrieveNotReachableExpiredTasks())
          }
          loading={status === 'loading'}
        />
        {count > 0 && (
          <Pagination
            className="mx-auto mt-4 d-flex justify-content-center"
            count={Math.ceil(count / taskRedux.TASKS_PER_PAGE)}
            page={page}
            onChange={onPageChange}
          />
        )}
      </div>
    </div>
  );
}

export default NotReachableExpiredTable;
